import React from "react";
import { Button } from "@fluentui/react-northstar";

const CancelAssistanceButton = (props) => (
  <Button
    data-testid="cancelAssistanceButton"
    content="Cancel Request Assistance"
    secondary
    onClick={props.onClick}
  />
);

export default CancelAssistanceButton;
